// MemberConnectionStatus moved to the foundational `common` layer (so `common`
// no longer depends on `accounts`). Re-exported here to preserve the public
// `@mx-cartographer/experiences/accounts` API.
export { MemberConnectionStatus } from '../../common/constants/Connect'

export enum FieldType {
  Currency = 'currency',
  Date = 'date',
  Input = 'input',
  Select = 'select',
}
